import { Component, Inject, Optional } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';
import { MessageTransportService } from '@nx-fe/services';
import { CellRendererBase, CellRendererData, CELL_RENDERER_TOKEN } from '../cell-renderer';
import { IconCellIcon, LinkCellData, LinkCellEvent } from '../renderer.models';

@Component({
  selector: 'ins-link-cell-renderer',
  templateUrl: './link-cell-renderer.component.html',
  styleUrls: ['./link-cell-renderer.component.scss'],
})
export class LinkCellRendererComponent extends CellRendererBase {
  dataToRender = '';
  textValue = '';
  data: any;
  icons: IconCellIcon[];
  iconClass: string;
  outputEvent: CellRendererData<string> | LinkCellEvent;
  readonly DEFAULT_EVENT_ID = 'linkCellRendererClicked';
  eventId: string = this.DEFAULT_EVENT_ID;

  constructor(
    @Inject(CELL_RENDERER_TOKEN)
    @Optional()
    params: CellRendererData<object | boolean | string | number>,
    protected _eventTransportService: MessageTransportService,
    private xsI18nPipe: XsI18nPipe
  ) {
    super(params, _eventTransportService);
  }

  private static instanceOfLinkCellData(obj: any): obj is LinkCellData {
    //not primitive
    return obj === Object(obj);
  }

  textClick(event: Event): void {
    if (this.outputEvent['column'] && this.outputEvent['column']['colId'] === 'reportLink') {
      const url = this.outputEvent['data'];
      window.open(url, '_blank');
    }
    event.stopPropagation();
    console.log(this.eventId);
    this._eventTransportService.event(this.eventId).emit(this.outputEvent);
  }

  init(cellData: CellRendererData<string | LinkCellData>): void {
    if (cellData.params && cellData.params.icons) {
      this.icons = cellData.params.icons;
    }

    this.data = cellData.data;
    if (!this.data) {
      this.textValue = this.xsI18nPipe.transform('constant_not_applicable_label');
      this.outputEvent = cellData as CellRendererData<string>;
      return;
    }

    if (LinkCellRendererComponent.instanceOfLinkCellData(this.data)) {
      if (this.data.params && this.data.params.icons) {
        this.icons = this.data.params.icons;
      }

      this.eventId = this.data.params['eventId'] || this.DEFAULT_EVENT_ID;
      this.textValue = this.data.text ? this.data.text : this.xsI18nPipe.transform('constant_not_applicable_label');
      this.dataToRender = this.textValue;
      this.outputEvent = {
        rowContext: this.data.rowContext,
        parameters: this.data.params['eventParams'] || {},
      };
    } else {
      //maintain backward compatibility
      this.textValue = String(this.data);
      this.outputEvent = cellData as CellRendererData<string>;
    }
  }
}
